import React from "react";
import { API } from "@/lib/api";

export function Logo({ size = 40, className = "" }) {
  return (
    <img
      src={`${API}/design/logo`}
      alt="RoyalChat Nova"
      width={size}
      height={size}
      className={`rounded-xl object-cover ${className}`}
      style={{ boxShadow: "0 0 24px rgba(212,175,55,0.18)" }}
      data-testid="royal-logo"
    />
  );
}

export function Wordmark({ size = 40, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo size={size} />
      {showText && (
        <span className="font-heading font-semibold tracking-tight leading-none text-[var(--rc-text)]"
          style={{ fontSize: size * 0.62 }}>
          Royal<span className="text-[var(--rc-gold)]">Chat</span> Nova
        </span>
      )}
    </div>
  );
}
